import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { pollBulkJobParallel } from '@src/utility/CommonBulkPoll';
import { SMART_EDIT_OVER_TIMES_DATA_API_BULK_URL, SMART_EDIT_OVER_TIMES_DATA_API_URL, SMART_EDIT_STATUS_DATA_API_URL, SMART_EDIT_STATUS_DATA_API_BULK_URL, SMART_EDIT_TOP_CLAIM_DATA_API_URL, SMART_EDIT_TOP_REASONS_DATA_API_URL, SMART_EDIT_TOP_REASONS_DATA_API_BULK_URL, SMART_EDITS_SUMMARY_DATA_API_URL, SMART_EDITS_SUMMARY_DATA_API_BULK_URL } from './apiUrlConstants';

const _httpService = new HttpService();
const _httpServiceBulk = new HttpService();

const apiDomainInternal = config('API_DOMAIN_INTERNAL') ?? '';
const apiDomainExternal = config('API_DOMAIN_EXTERNAL') ?? '';

if (checkIsInternal()) {
  _httpService.setBaseURL(apiDomainInternal);
  _httpServiceBulk.setBaseURL(config('BULK_PROCESSING_API') || '');
} else {
  _httpService.setBaseURL(apiDomainExternal);
  _httpServiceBulk.setBaseURL(config('BULK_PROCESSING_API') || '');
}

export const getSmartEditsSummaryDataRequest = async (payload: any, showGeoSegView: boolean = false) => {
  const url = `${SMART_EDITS_SUMMARY_DATA_API_URL}`;
  const httpService = showGeoSegView ? _httpServiceBulk : _httpService;
  const responseData: any = await httpService.push(url, payload);
  return responseData.Data;
};

// High Volume TIN Flow - Parallel polling for SmartEdits Summary
export const getSmartEditsSummaryBulkRequest = async (payload: any): Promise<any> => {
  const url = `${SMART_EDITS_SUMMARY_DATA_API_BULK_URL}`;
  const result = await pollBulkJobParallel<any>(url, payload);
  return result;
};

export const getSmartEditStatusDataRequest = async (payload: any, showGeoSegView: boolean = false) => {
  const url = `${SMART_EDIT_STATUS_DATA_API_URL}`;
  const httpService = showGeoSegView ? _httpServiceBulk : _httpService;
  const responseData: any = await httpService.push(url, payload);
  return responseData.Data;
};

// High Volume TIN Flow - Parallel polling for SmartEdit Status
export const getSmartEditStatusBulkRequest = async (payload: any): Promise<any> => {
  const url = `${SMART_EDIT_STATUS_DATA_API_BULK_URL}`;
  const result = await pollBulkJobParallel<any>(url, payload);
  return result;
};

export const getSmartEditTopReasonsDataRequest = async (payload: any, showGeoSegView: boolean = false) => {
  const url = `${SMART_EDIT_TOP_REASONS_DATA_API_URL}`;
  const httpService = showGeoSegView ? _httpServiceBulk : _httpService;
  const responseData: any = await httpService.push(url, payload);
  return responseData.Data;
};

// High Volume TIN Flow - Parallel polling for SmartEdit Top Reasons
export const getSmartEditTopReasonsBulkRequest = async (payload: any): Promise<any> => {
  const url = `${SMART_EDIT_TOP_REASONS_DATA_API_BULK_URL}`;
  const result = await pollBulkJobParallel<any>(url, payload);
  return result;
};

export const getSmartEditTopClaimDataRequest = async (payload: any) => {
  const url = `${SMART_EDIT_TOP_CLAIM_DATA_API_URL}`;
  const responseData: any = await _httpService.push(url, payload);
  return responseData.Data;
};
export const getSmartEditOverTimesDataRequest = async (payload: any, type: string, showGeoSegView: boolean = false) => {
  const url = `${SMART_EDIT_OVER_TIMES_DATA_API_URL}` + type;
  const httpService = showGeoSegView ? _httpServiceBulk : _httpService;
  const responseData: any = await httpService.push(url, payload);
  return responseData.Data;
};

// High Volume TIN Flow - Parallel polling for SmartEdits Over Time
export const getSmartEditOverTimesBulkRequest = async (payload: any, type: string): Promise<any> => {
  const url = `${SMART_EDIT_OVER_TIMES_DATA_API_BULK_URL}` + type;
  const result = await pollBulkJobParallel<any>(url, payload);
  return result;
};